import { render, staticRenderFns } from "./DashTour.vue?vue&type=template&id=0f28c32c"
import script from "./DashTour.vue?vue&type=script&lang=js"
export * from "./DashTour.vue?vue&type=script&lang=js"
import style0 from "./DashTour.vue?vue&type=style&index=0&id=0f28c32c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports